import DriverStoriesApi from "../../services/api/DriverStories";

import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in driver stories actions :", err);
}

const convertElementsToString = (entity_value) => {
  return entity_value.map((e) => e.toString());
};

export const resetToInitialState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE,
    payload,
  };
};

export const resetState = (state) => async (dispatch) => {
  let payload = {
    state: state,
  };
  dispatch(resetToInitialState(payload));
};

const GeographyLevelMapping = {
  city: "City",
  country: "Country",
  state: "State",
  locality: "Locality",
};

export const createPayloadForStoryCreation = (payload) => {
  const {
    requester_type,
    requester_id,
    upload_cohort_type,
    conditions = [],
    expiry_time,
    media_type,
    image_url,
    video_url,
    csv_file_s3_key,
    csv_data,
    click_to_action,
    meta_data,
    geography_details: {
      city_ids,
      country_id,
      state_ids,
      geography_level,
      locality_ids,
    },
    driver_details,
    cdn_video_url,
  } = payload;

  const entity_type = GeographyLevelMapping[geography_level];
  let entity_value = [];
  switch (entity_type) {
    case GeographyLevelMapping.city:
      entity_value = city_ids;
      break;

    case GeographyLevelMapping.country:
      entity_value = ["1"]; // India country code
      break;

    case GeographyLevelMapping.locality:
      entity_value = locality_ids;
      break;

    case GeographyLevelMapping.state:
      entity_value = state_ids;
      break;
  }

  let date = new Date();
  if (expiry_time) {
    date = new Date(expiry_time);
  } else {
    date.setDate(date.getDate() + 7);
  }

  let requesterId;
  if (requester_type === "EXTERNAL_ENTITY") {
    requesterId = requester_id;
  } else {
    requesterId = (driver_details?.id ?? -1).toString();
  }

  const updatedPayload = {
    requester_type,
    requester_id: requesterId,
    upload_cohort_type,
    conditions,
    expiry_time: date.toISOString(),
    media_type,
    url: cdn_video_url || (media_type === "VIDEO" ? video_url : image_url),
  };

  if (upload_cohort_type === "GEOGRAPHY") {
    updatedPayload.entity_value = convertElementsToString(entity_value);
    updatedPayload.entity_type = entity_type;
  } else {
    updatedPayload.csv_file_s3_key = csv_file_s3_key;
    updatedPayload.callback_key = csv_data.callback_key ?? "";
  }
  if (Object.keys(click_to_action).length > 0) {
    updatedPayload.click_to_action = click_to_action;
    updatedPayload.click_to_action.action_type = "deeplink";
  }
  if (Object.keys(meta_data).length > 0) {
    updatedPayload.click_to_action = {
      name: meta_data.text,
      action_type: "share_to_whatsapp",
    }
    updatedPayload.metaData = [
      {
        key: "phone_number",
        value: meta_data.phone_number,
      },
      {
        key: "message",
        value: meta_data.message,
      },
      {
        key: "image",
        value: meta_data.image,
      },
    ];
  }
  return updatedPayload;
};

export const createStoryCampaign = (payload) => async (dispatch) => {
  const requestPayload = createPayloadForStoryCreation(payload);
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.createStoryCampaign(requestPayload);
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setStoriesList = (payload) => {
  return {
    type: ActionTypes.SET_STORIES_LIST,
    payload,
  };
};

export const setActiveCampaign = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_STORY_CAMPAIGN,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION,
    payload,
  };
};

export const getActiveCampaign = (campaign_id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.getActiveCampaign(campaign_id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveCampaign(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const driverSelectionCSVUpload = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.driverSelectionCSVUpload(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const uploadCampaignImage = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    // let response = await DriverStoriesApi.uploadCampaignImage(payload);
    let response = await DriverStoriesApi.uploadCampaignImage(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const uploadCampaignVideo = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    // let response = await DriverStoriesApi.uploadCampaignImage(payload);
    let response = await DriverStoriesApi.uploadCampaignVideo(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const fetchStoriesList =
  (
    filters = {},
    pageRequest = {
      page: 1,
      page_size: 10,
    }
  ) =>
  async (dispatch) => {
    try {
      let body = {
        page_request: pageRequest,
        ...filters,
      };
      dispatch(setLoader(true));
      let response = await DriverStoriesApi.fetchStoriesList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setStoriesList(response));
        dispatch(setActiveFilters(filters));
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.NOT_FOUND,
        })
      );
      handleError(err);
    }
  };

export const deactivateStory = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.deactivateStory(payload);
    return response;
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.NOT_FOUND,
      })
    );
    handleError(err);
  }
};

export const getDriverDetails = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.getDriverDetails(driverId);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createExternalEntity = (payload) => async (dispatch) => {
  const requestPayload = {
    name: payload.name,
    preview_image_url: payload.image_url,
  };
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.createExternalEntity(requestPayload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getExternalEntitiesList = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    payload = {}
    let response = await DriverStoriesApi.getExternalEntitiesList(payload);
    dispatch(setLoader(false));
    if (response) {
      return response.external_entities;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getExternalEntity = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoriesApi.getExternalEntity(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};